import React from 'react';
import PropTypes from 'prop-types';
import InfoBanner from '../../../info-banner';
import InfoText from '../../../info-banner/components/textinfo';

function ErrorList({ errors }) {
  if (errors.length === 0) {
    return null;
  }

  return errors.map(
    (error, index) =>
      error && (
        <InfoBanner styling="error" accent key={`error-item-${index}`}>
          <InfoText text={error} styling="error" />
        </InfoBanner>
      )
  );
}

ErrorList.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string)
};

ErrorList.defaultProps = {
  errors: []
};

export default ErrorList;
